import React, { useState } from "react";
import Drawer from 'react-modern-drawer';
import contactService from "./contactService";
import Pagination from "components/Common/newPagination";
import DeleteDialogueBox from "../Common/deleteDialogue";

export function ContactFormSearch(param: any) {

    let [isOpen, setIsOpen] = useState(false);
    let [creatorFlag, setcreatorFlag] = useState(false);
    let [digitalprovideropt, setdigitalprovideropt] = useState("All");
    let [contactNameOrCode, setcontactNameOrCode] = useState("");
    let [addContact, setaddContact] = useState(false);
    let [emptyField, setemptyField] = useState(false);
    let [ContactList, initContactList] = useState<any[]>([]);
    let [ContactListSearch, initContactSearchList] = useState<any[]>([]);
    let [totalRows, setTotalRows] = useState(0);
    let [deleteJob, setDelete] = useState(0);
    let [deletekontactName, setdeletekontactName] = useState<any>([]);

    var payload = { "pageSize": 1, 'pageNumber': 10, "creator": creatorFlag, "digitalOnly": digitalprovideropt === "All" ? null : false, "contactNameOrCode": contactNameOrCode }

    const searchContact = () => {
        if (contactNameOrCode !== '') {
            setemptyField(false)
            if (digitalprovideropt === "All") {
                payload.digitalOnly = null;
            }

            if (digitalprovideropt === "Only") {
                payload.digitalOnly = true;
            }

            if (digitalprovideropt === "Non") {
                payload.digitalOnly = false;
            }

            contactService.SelectContact({ ...payload, 'pageSize': 10, 'pageNumber': 10 }).then((res) => {
                initContactList(res)
                initContactSearchList(res)
                setTotalRows(res[0] ? res.length : 0);

                if (res.length > 0) {
                    ContactListSearch = res;
                    var obj = res.splice(0, 10)
                    initContactList(obj)
                }
            })
        } else {
            setemptyField(true)
        }
    }

    const Confirmation = (e: any) => {

        if (e === 1) {
            contactService.deleteContact(deletekontactName);
            contactService.SelectContact(payload).then((res: any) => {
                initContactList(res)
                setTotalRows(res[0] ? res[0].totalRows : 0)
            })
        }
        setDelete(0);
    }

    const handleNameOnChange = (n: any) => {
        ContactList = ContactListSearch;
        var num = n.pageNumber;
        var size = n.pageSize;
        var obj = ContactList.splice((num), size)
        initContactList(obj)
    }

    const selectContact = (e: any) => {
        param.onChange(e)
    }

    return (<div >

        <button type="button" className="icon-btn info width70 height35" onClick={() => { setIsOpen(true) }}><i className="icon-user-add"></i></button>
        <Drawer open={isOpen} onClose={() => setIsOpen(false)} direction='right' className='react-drawer allowHscroll allowVscroll '>

            <div className="ws-8 box pull-right  full-height-vh allowHscroll allowVscroll landing">

                <div className="modal-header">
                    <div className="box-header-main">
                        <h2 className="ws-10">Search Contact Form</h2>
                        <a className="icon-btn delete pull-right btn-xxs">
                            <i className="icon-close" onClick={() => setIsOpen(false)}></i>
                        </a>
                    </div>
                </div>

                <div className="ws-12 pm landing">

                    <div className="pm box ">
                        <div className="box-content ">
                            {emptyField && <div className="alert alert-info">Try entering a Contact Code to search</div>}

                            <div className="ws-12">

                                <div className=" ws-4">
                                    <label className="control-label p0" >Contact code/display/name</label>
                                    <div className="label-entries">
                                        <input type="text" className="form-control forceSingleLine" onChange={(e: any) => setcontactNameOrCode(e.target.value)} placeholder="Enter Contact Code/Display/Name" name="searchBox" />
                                    </div>
                                </div>

                                <div className=" ws-1">
                                    <label>Creator</label>
                                    <label className="switch">
                                        <input type="checkbox" checked={creatorFlag} name="creatorFlag" onClick={() => setcreatorFlag(!creatorFlag)} />
                                        {creatorFlag && <span className="slider round text-left white pm pts " >Yes</span>}
                                        {!creatorFlag && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                    </label>
                                </div>

                                <div className=" ws-7 mtl">
                                    <div className="ws-12 ptxl">
                                        <div className="ws-2 forceSingleLine" onClick={() => setdigitalprovideropt("All")}  > <input type="radio" value="null" checked={true} name="digitalprovideropt" /> All </div>
                                        <div className="ws-5 forceSingleLine" onClick={() => setdigitalprovideropt("Only")} > <input type="radio" name="digitalprovideropt" />Digital Provider Only</div>
                                        <div className="ws-5 forceSingleLine" onClick={() => setdigitalprovideropt("Non")}> <input type="radio" name="digitalprovideropt" /> Non digital Provider</div>
                                    </div>
                                </div>

                            </div>

                            <div className="ws-6 pull-right">
                                <a className="icon-btn edit width100 height35 mr pull-right" onClick={searchContact}><i className="icon-search"></i>Search </a>
                                <a className="icon-btn edit width100 height35 hide pull-right"><i className="icon-tick"></i> New Contact</a>
                            </div>

                        </div>
                    </div>

                    <div className="ws-12 mtl">

                        <h3 className="capitalize mb pull-left ws-5 ptl">  {totalRows} record(s) found  </h3>

                        {addContact && <div className="alert alert-success"> Contact  has been deleted successfully </div>}

                        {(totalRows === 0) && <div className="alert alert-info">No records to display </div>}

                        {(totalRows > 0) && <div className="table-responsive">
                            <table className="newTable">
                                <thead>
                                    <tr className="forceSingleLine">
                                        <th>Contact code</th>
                                        <th>Contact display</th>
                                        <th>Contact name</th>
                                        <th style={{ width: "110px" }}>Operation</th>
                                    </tr>
                                </thead>
                                {ContactList?.map((value) => {
                                    return (
                                        <tr>
                                            <td>{value.kontactCode} </td>
                                            <td>{value.kontactDisplay} </td>
                                            <td>{value.kontactName} </td>
                                            <td style={{ width: "15px" }}>
                                                <a className="icon-btn edit btn-sm" onClick={() => { selectContact(value); setIsOpen(false) }}><i className="icon-user-add"></i></a>
                                                <a className="icon-btn edit btn-sm hide" ><i className="icon-edit"></i></a>
                                                <a className={value.enableDeleteFlag ? "icon-btn delete btn-sm " : "hide"} onClick={() => { setDelete(1); setdeletekontactName(value) }}><i className="icon-close"></i> </a>
                                            </td>
                                        </tr>
                                    )
                                })}
                                <tbody>
                                </tbody>
                            </table>
                        </div>}

                        <div className="ws-12">
                            {
                                (() => {
                                    if (totalRows > 0 && totalRows > 10) { return <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} /> }
                                })()
                            }
                        </div>

                        {(totalRows > 0 || true) && <div className="box-footer ">
                            <button className="icon-btn delete width100 height35" onClick={() => setIsOpen(false)}>Close </button>
                        </div>}

                        {
                            (() => {
                                if (deleteJob && deleteJob === 1) {
                                    return <DeleteDialogueBox param={true} message={"delete contact " + deletekontactName.kontactName} onChange={Confirmation} />
                                }
                            })()
                        }

                    </div>

                </div>
            </div>
        </Drawer>

    </div>)
}